import { jsonp, ajax } from '@ifeng/ui_base';
import md5 from 'md5';
import axios from 'axios';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
const apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

// jsonp 接口请求示例 ---- start (开发时请删除示例代码)
// jsonp 接口请求示例 ---- start (开发时请删除示例代码)
// jsonp 接口请求示例 ---- start (开发时请删除示例代码)

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

const getMyStockData = async (num) => {
    return await jsonp('//apiapp.finance.ifeng.com/mystock/get', {
        data: { num },
        jsonpCallback: createJsonpCallbackName('getMyStockData'),
        cache: false,
    });
};

const getTokenData = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https:/xxx.ifeng.com/phtv/host/sign/uplaod/${type}/token/${timeStamp}`);
};

const saveMediaFile = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv/host/sign/${type}/commit/${timeStamp}`, data);
};
/**
 * 上传视频
 * ***/
const getVideoFileKey = async (formData, onUploadProgress) => {
    const result = await axios.post('https://special-leads.ifeng.com/api/upload-video', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });

    if (result.status < 400) {
        if (result.data.code === 1) {
            return result.data;
        } else {
            throw new Error(result.data.message);
        }
    } else {
        throw new Error('网络异常');
    }
};
/**
 * 上传图片
 * ***/
const getImgFileKey = async (formData) => {
    const result = await axios.post('https://special-leads.ifeng.com/api/upload-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    if (result.status < 400) {
        if (result.data.code === 1) {
            return result.data;
        } else {
            throw new Error(result.data.message);
        }
    } else {
        throw new Error('网络异常');
    }
};

const submitFormHandle = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv/host/sign/commit/${timeStamp}`, data);
};

const getTokenData2024 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https:/xxx.ifeng.com/phtv2024/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFile2024 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv2024/host/sign/${type}/commit/${timeStamp}`, data);
};

const updateFormHandle2024 = async (data, updateId) => {
    const timeStamp = new Date().getTime();
    const fromNameMap = {
        name: 'name', // 姓名
        gender: 'gender', // 性别
        age: 'age', // 年龄
        current_college: 'background', // 在读/毕业院校
        major: 'industry', // 专业/职业
        contact_details: 'mobile', // 联系方式
        nationality: 'source', // 国籍
        img1: 'memo1', // 形象照片
        img2: 'memo2', // 形象照片
        info1: 'otherBrandPropaganda', // 请用三个特点让人记住你
        info2: 'interested', // 一句话喊出你的参赛宣言
        video_self: 'friContact', // 视频作品
        socialAccount: 'email1', // 经营个人社交媒体账号
        satisfiedPlatform: 'email2', // 最满意的社交媒体账号位于哪个平台？
        videoLink: 'otherInterested', // 个人最满意的短视频作品链接？
        video_production: 'secContact', // 选填视频作品
        language: 'boxNum', // 擅长语种
        self_introduction: 'other_form_value', // 详细秀一下自己
        other_platforms: 'address', // 还能在哪些平台了解你
    };
    const formdata = new FormData();

    for (const key in data) {
        if (fromNameMap.hasOwnProperty(key)) {
            const key2 = fromNameMap[key];

            formdata.append(key2, data[key]);
        } else {
            formdata.append(key, data[key]);
        }
    }

    formdata.append('specialname', '吉利新主播');
    formdata.append('specialcname', 'JL20250721');
    formdata.append('dealer_pool_id', '336');

    return await axios.post('https://special-leads.ifeng.com/api/collectInfo', formdata);
};

const submitFormHandle2024 = async (data) => {
    return await updateFormHandle2024(data, '');
};

const getHostHandle2024 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://xxx.ifeng.com/host/sign/get/${updataId}/info/${timeStamp}`);
};

const getTokenDataHK2024 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https:/xxx.ifeng.com/phtv2024/hk/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFileHK2024 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv2024/hk/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandleHK2024 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv2024/hk/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandleHK2024 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https:/xxx.ifeng.com/phtv2024/hk/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandleHK2024 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://xxx.ifeng.com/api/phtv2024/hk/host/sign/get/${updataId}/info/${timeStamp}`);
};

// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)

export {
    getTokenDataHK2024,
    saveMediaFileHK2024,
    submitFormHandleHK2024,
    updateFormHandleHK2024,
    getHostHandleHK2024,
    getMyStockData,
    getTokenData,
    getImgFileKey,
    getVideoFileKey,
    submitFormHandle,
    saveMediaFile,
    getTokenData2024,
    saveMediaFile2024,
    submitFormHandle2024,
    getHostHandle2024,
    updateFormHandle2024
};
